import Form from './Form';

function App() {
	return (
		<section className='form'>
			<Form />
		</section>
	);
}

export default App;
